'use client';

/**
 * Global Error Component for Next.js 16
 * This file is required to work around a known issue with React 19 and Next.js 16
 * where the auto-generated global-error page causes build failures.
 * See: https://github.com/vercel/next.js/issues/85668
 */

// Force dynamic rendering to avoid prerender issues
export const dynamic = 'force-dynamic';

// Minimal error component without any hooks or context dependencies
function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: 'system-ui, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Something went wrong!</h1>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            An unexpected error occurred
          </p>
          <button
            onClick={() => reset?.() || window.location.reload()}
            style={{
              padding: '12px 24px',
              backgroundColor: '#0070f3',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}

export default GlobalError;
